import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { useDataProvider } from './DataProvider';

export const PublicRoute = ({ component: Component, restricted, ...rest }) => {
    const { currentUser } = useDataProvider();
    const location = useLocation();

    return (
        <Route {...rest} render={props => (
            currentUser && restricted
                ? <Redirect to={{
                    pathname: '/',
                    state: { prev: location.state?.prev || location.pathname }
                }} />
                : <Component {...props} />
        )} />
    );
};

export const PrivateRoute = ({ component: Component, ...rest }) => {
    const { currentUser } = useDataProvider();
    const location = useLocation();

    return (
        <Route {...rest} render={props => (
            currentUser
                ? <Component {...props} />
                : <Redirect to={{
                    pathname: '/sign',
                    state: { prev: location.state?.prev || location.pathname }
                }} />
        )} />
    );
};
